import { call, takeLeading, put, select } from 'redux-saga/effects';
import { makeSelectLockedClaim } from 'containers/LawyerLegalProceedingsPage/selectors';
import routesHelper from 'containers/services/routes-helper';
import {
  request,
  handleError,
  ResponseError,
  callApi,
} from 'helpers/saga-helpers';
import { PAGES } from 'routes';
import {
  LOGIN_REQUESTED,
  LOGOUT_REQUESTED,
} from 'containers/LoginPage/constants';
import loginDataStorageService, {
  LoginResponse,
} from 'containers/services/security/login-data-storage-service';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import accessTokenStorage from 'containers/services/security/access-token-storage';
import { resetStore } from 'containers/LoginPage/actions';
import { get, isNil } from 'lodash';

export function* logIn(action: any): Generator<LoginResponse | ResponseError> {
  const path = '/sagis/login-corporeal-manager';
  const options: any = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...action.payload,
    }),
  };
  try {
    const loginResponse = yield (call(
      request,
      path,
      options,
    ) as unknown) as LoginResponse;

    loginDataStorageService.storeLoginData(loginResponse as LoginResponse);

    const privileges = get(loginResponse, ['data', 'privileges'], undefined);
    if (privileges.isOpeningManager) routesHelper.pushTo(PAGES.MANAGER_HOME)();
    else if (privileges.isPreOpenManager)
      routesHelper.pushTo(PAGES.PREOPEN_MANAGER_HOME)();
    else if (privileges.isCourtManager || privileges.isCourtMonitoringManager)
      routesHelper.pushTo(PAGES.COURT_MANAGER_HOME)();
    else if (privileges.isConsultationManager)
      routesHelper.pushTo(PAGES.CONSULTATION_MANAGER_HOME)();
    else if (privileges.isTransactionManager)
      routesHelper.pushTo(PAGES.TRANSACTION_MANAGER_HOME)();
  } catch (error) {
    yield* (handleError(
      (error as unknown) as ResponseError,
    ) as unknown) as Generator<ResponseError>;
  }
}

export function* loginSaga() {
  yield takeLeading(LOGIN_REQUESTED, logIn);
}

export function* logOut(): Generator<unknown> {
  try {
    if (featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM)) {
      const lockedClaimNumber = yield select(makeSelectLockedClaim());
      const token = accessTokenStorage.get().token;
      const path = `/sagis/claim/unlock`;
      if (!isNil(lockedClaimNumber)) {
        const options = {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            claimNumber: lockedClaimNumber,
          }),
        };

        const errorResponse = yield callApi(path, {}, options);
        if (!errorResponse) {
          yield put(resetStore());
          loginDataStorageService.clearLoginData();
          routesHelper.pushTo(PAGES.LOGIN_MANAGER)();
        }
      } else {
        yield put(resetStore());
        loginDataStorageService.clearLoginData();
        routesHelper.pushTo(PAGES.LOGIN_MANAGER)();
      }
    } else {
      yield put(resetStore());
      loginDataStorageService.clearLoginData();
      routesHelper.pushTo(PAGES.LOGIN_MANAGER)();
    }
  } catch (error) {
    yield* handleError((error as unknown) as ResponseError);
  }
}

export function* logOutSaga() {
  yield takeLeading(LOGOUT_REQUESTED, logOut);
}
